export const chartsTranslations = {
  en: {
    charts: {
      captions: {
        compoundInterest: "Comparison: €10,000 with simple vs compound interest at 10% annual over 30 years",
        emergencyFund: "Recommended budget distribution to build your emergency fund",
        etfComparison: "Evolution of €100 invested in different ETFs since 2019",
        firstSalaryAllocation: "Recommended distribution of your first salary: the 50/30/20 rule",
        impulseBuyingCost: "The real cost of impulse purchases and their potential if invested",
        inflationImpact: "Impact of inflation: how €10,000 loses purchasing power at 3% annual inflation",
        fireTimeline: "Years to financial independence based on your savings rate",
        opportunityCost: "Opportunity cost: small invisible expenses and their impact if invested",
        lifestyleInflation: "Lifestyle inflation impact: expenses that grow with salary vs necessary expenses",
        monthlySavingsChallenge: "52-week savings challenge: start with €1 and end with €1,378 saved",
        costNotInvesting: "The cost of not investing: €10,000 cash vs invested at 7% over 30 years",
        retirementProjection: "Retirement savings projection: saving €500/month from age 25",
        mortgageComparison: "€200,000 mortgage evolution: remaining principal vs interest paid",
        riskReturn: "Investment profile comparison: expected return vs volatility",
        roboadvisorComparison: "Comparison: Roboadvisors vs Human Advisors across different criteria",
        salaryGrowth: "Salary growth: negotiating vs not negotiating over 25 years",
        investingBeginners: "Investment options comparison for beginners: return vs risk",
        dcaVsLumpsum: "DCA (€1,000/month) vs Lump Sum (€12,000) comparison with 6% annual return",
        cryptoVolatility: "Volatility comparison: cryptocurrencies vs traditional assets",
        dividendGrowth: "Growth with dividend reinvestment: €10,000 initial with 4% annual dividend",
        bnplCost: "Real cost of a €100 purchase by financing method",
      },
      compoundInterest: {
        simpleInterest: "Simple Interest",
        compoundInterest: "Compound Interest",
        years: "Years",
      },
      inflation: {
        nominalValue: "Nominal Value",
        purchasingPower: "Real Purchasing Power",
        yearsInflation3: "Years (3% inflation)",
      },
      savingsGrowth: {
        monthlySaving: "Monthly Savings",
        totalAccumulated: "Total Accumulated",
        month: "Month",
        jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr", may: "May", jun: "Jun",
        jul: "Jul", aug: "Aug", sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
      },
      investmentComparison: {
        savingsAccount: "Savings Account",
        govBonds: "Gov. Bonds",
        corpBonds: "Corp. Bonds",
        realEstate: "Real Estate",
        stocks: "Stocks",
        crypto: "Crypto",
        expectedReturn: "Expected Return (%)",
        riskLevel: "Risk Level",
        assetType: "Asset Type",
      },
      emergencyFund: {
        essentialExpenses: "Essential Expenses",
        variableExpenses: "Variable Expenses",
        savingsInvestment: "Savings/Investment",
        recommendedDistribution: "Recommended Budget Distribution",
      },
      dcaVsLumpsum: {
        dca: "DCA (€1000/month)",
        lumpsum: "Lump Sum (€12000)",
        months: "Months",
      },
      riskReturn: {
        conservative: "Conservative",
        moderate: "Moderate",
        aggressive: "Aggressive",
        veryAggressive: "Very Aggressive",
        annualReturn: "Annual Return (%)",
        volatility: "Volatility (%)",
        riskProfile: "Risk Profile",
      },
      retirement: {
        withoutInvesting: "Savings without investing",
        invested: "Invested (7% return)",
        age: "Age",
      },
      budgetBreakdown: {
        housing: "Housing",
        food: "Food",
        transport: "Transport",
        utilities: "Utilities",
        savings: "Savings",
        leisure: "Leisure",
        rule502030: "50/30/20 Rule Adapted",
      },
      etf: {
        sp500: "S&P 500",
        msciWorld: "MSCI World",
        emerging: "Emerging Markets",
        year: "Year",
        initial100: "€100 initial",
      },
      dividend: {
        withoutReinvesting: "Dividends without reinvesting",
        withReinvesting: "Dividends reinvested",
        years: "Years",
      },
      mortgageAmortization: {
        pendingCapital: "Pending Capital",
        totalPaid: "Total Paid",
        years: "Years",
      },
      taxBrackets: {
        marginalRate: "Marginal Rate (%)",
        bracket: "Bracket",
      },
      lifestyle: {
        necessaryExpenses: "Necessary Expenses",
        withInflation: "With Lifestyle Inflation",
        annualSalary: "Annual Salary",
        expenses: "€ Expenses",
      },
      opportunity: {
        dailyCoffee: "Daily Coffee",
        subscriptions: "Subscriptions",
        eatingOut: "Eating Out",
        impulseClothing: "Impulse Clothing",
        total: "Total",
        yearlyCost: "Yearly Cost (€)",
        invested10years: "Invested 10 years (€)",
        expense: "Expense",
      },
      fire: {
        yearsToFire: "Years to FIRE",
        savingsRate: "Savings Rate",
      },
      crypto: {
        savingsAccount: "Savings Account",
        bonds: "Bonds",
        sp500: "S&P 500",
        gold: "Gold",
        bitcoin: "Bitcoin",
        altcoins: "Altcoins",
        annualVolatility: "Annual Volatility (%)",
        maxDrawdown: "Max Drawdown (%)",
        asset: "Asset",
      },
      salary: {
        withoutNegotiating: "Without negotiating (+3%/year)",
        withNegotiating: "With negotiating (+5%/year)",
        careerYears: "Career Years",
        yearlyEuro: "€/year",
      },
      firstSalary: {
        needs: "Needs (50%)",
        wants: "Wants (30%)",
        savings: "Savings (20%)",
        rule502030FirstSalary: "50/30/20 Rule for your first salary",
      },
      impulse: {
        impulsePurchases: "Impulse Purchases",
        fastFood: "Fast Food",
        appsGames: "Apps/Games",
        unnecessaryClothing: "Unnecessary Clothing",
        yearlyCost: "Yearly Cost (€)",
        ifInvested5y: "If invested 5 years (€)",
        category: "Category",
      },
      mortgage: {
        remainingPrincipal: "Remaining Principal",
        interestPaid: "Interest Paid",
        years: "Years",
      },
      savings: {
        week1: "Week 1",
        week10: "Week 10",
        week20: "Week 20",
        week30: "Week 30",
        week40: "Week 40",
        week52: "Week 52",
        weeklySaving: "Weekly Saving (€)",
        totalAccumulated: "Total Accumulated (€)",
        week: "Week",
      },
      beginners: {
        savingsAccount: "Savings Account",
        fixedDeposit: "Fixed Deposit",
        indexFunds: "Index Funds",
        stocks: "Stocks",
        realEstate: "Real Estate",
        expectedReturn: "Expected Return (%)",
        riskLevel: "Risk (1-10)",
        investmentOption: "Investment Option",
      },
      costNotInvesting: {
        cashMoney: "Cash Money",
        invested7percent: "Invested at 7%",
        years: "Years",
      },
      robo: {
        annualFee: "Annual Fee",
        minInvestment: "Min Investment (k€)",
        personalization: "Personalization (1-10)",
        availability247: "24/7 Availability",
        emotionalManagement: "Emotional Management",
        roboadvisor: "Roboadvisor",
        humanAdvisor: "Human Advisor",
        feature: "Feature",
      },
      bnpl: {
        cashPayment: "Cash Payment",
        threeInstallments0: "3 Installments 0%",
        sixInstallments: "6 Installments",
        twelveInstallments: "12 Installments",
        revolvingCard: "Revolving Card",
        totalCost: "Total Cost (€)",
        paymentMethod: "Payment Method",
      },
    },
  },
  es: {
    charts: {
      captions: {
        compoundInterest: "Comparación: €10,000 con interés simple vs compuesto al 10% anual durante 30 años",
        emergencyFund: "Distribución recomendada del presupuesto para construir tu fondo de emergencia",
        etfComparison: "Evolución de €100 invertidos en diferentes ETFs desde 2019",
        firstSalaryAllocation: "Distribución recomendada de tu primer salario: la regla 50/30/20",
        impulseBuyingCost: "El coste real de las compras impulsivas y su potencial si se invirtieran",
        inflationImpact: "Impacto de la inflación: cómo €10,000 pierden poder adquisitivo con inflación del 3% anual",
        fireTimeline: "Años hasta la independencia financiera según tu tasa de ahorro",
        opportunityCost: "Coste de oportunidad: pequeños gastos invisibles y su impacto si se invirtieran",
        lifestyleInflation: "Impacto del lifestyle inflation: gastos que crecen con el salario vs gastos necesarios",
        monthlySavingsChallenge: "Reto de ahorro de 52 semanas: empieza con €1 y termina con €1,378 ahorrados",
        costNotInvesting: "El coste de no invertir: €10,000 en efectivo vs invertidos al 7% durante 30 años",
        retirementProjection: "Proyección de ahorro para jubilación: ahorrando €500/mes desde los 25 años",
        mortgageComparison: "Evolución de una hipoteca de €200,000: capital pendiente vs intereses pagados",
        riskReturn: "Comparación de perfiles de inversión: retorno esperado vs volatilidad",
        roboadvisorComparison: "Comparación: Roboadvisors vs Asesores Humanos en diferentes criterios",
        salaryGrowth: "Crecimiento salarial: negociar vs no negociar a lo largo de 25 años",
        investingBeginners: "Comparación de opciones de inversión para principiantes: retorno vs riesgo",
        dcaVsLumpsum: "Comparación DCA (€1,000/mes) vs Inversión única (€12,000) con rendimiento del 6% anual",
        cryptoVolatility: "Comparación de volatilidad: criptomonedas vs activos tradicionales",
        dividendGrowth: "Crecimiento con reinversión de dividendos: €10,000 iniciales con 4% dividendo anual",
        bnplCost: "Coste real de una compra de €100 según el método de financiación",
      },
      compoundInterest: {
        simpleInterest: "Interés Simple",
        compoundInterest: "Interés Compuesto",
        years: "Años",
      },
      inflation: {
        nominalValue: "Valor Nominal",
        purchasingPower: "Poder Adquisitivo Real",
        yearsInflation3: "Años (inflación 3%)",
      },
      savingsGrowth: {
        monthlySaving: "Ahorro Mensual",
        totalAccumulated: "Total Acumulado",
        month: "Mes",
        jan: "Ene", feb: "Feb", mar: "Mar", apr: "Abr", may: "May", jun: "Jun",
        jul: "Jul", aug: "Ago", sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dic",
      },
      investmentComparison: {
        savingsAccount: "Cuenta Ahorro",
        govBonds: "Bonos Gov.",
        corpBonds: "Bonos Corp.",
        realEstate: "Inmobiliario",
        stocks: "Acciones",
        crypto: "Crypto",
        expectedReturn: "Retorno Esperado (%)",
        riskLevel: "Nivel de Riesgo",
        assetType: "Tipo de Activo",
      },
      emergencyFund: {
        essentialExpenses: "Gastos Esenciales",
        variableExpenses: "Gastos Variables",
        savingsInvestment: "Ahorro/Inversión",
        recommendedDistribution: "Distribución Recomendada del Presupuesto",
      },
      dcaVsLumpsum: {
        dca: "DCA (€1000/mes)",
        lumpsum: "Lump Sum (€12000)",
        months: "Meses",
      },
      riskReturn: {
        conservative: "Conservador",
        moderate: "Moderado",
        aggressive: "Agresivo",
        veryAggressive: "Muy Agresivo",
        annualReturn: "Retorno Anual (%)",
        volatility: "Volatilidad (%)",
        riskProfile: "Perfil de Riesgo",
      },
      retirement: {
        withoutInvesting: "Ahorro sin invertir",
        invested: "Ahorro invertido (7%)",
        age: "Edad",
      },
      budgetBreakdown: {
        housing: "Vivienda",
        food: "Alimentación",
        transport: "Transporte",
        utilities: "Servicios",
        savings: "Ahorro",
        leisure: "Ocio",
        rule502030: "Regla 50/30/20 Adaptada",
      },
      etf: {
        sp500: "S&P 500",
        msciWorld: "MSCI World",
        emerging: "Emergentes",
        year: "Año",
        initial100: "€100 iniciales",
      },
      dividend: {
        withoutReinvesting: "Dividendos sin reinvertir",
        withReinvesting: "Dividendos reinvertidos",
        years: "Años",
      },
      mortgageAmortization: {
        pendingCapital: "Capital Pendiente",
        totalPaid: "Total Pagado",
        years: "Años",
      },
      taxBrackets: {
        marginalRate: "Tipo Marginal (%)",
        bracket: "Tramo",
      },
      lifestyle: {
        necessaryExpenses: "Gastos Necesarios",
        withInflation: "Con Lifestyle Inflation",
        annualSalary: "Salario Anual",
        expenses: "€ Gastos",
      },
      opportunity: {
        dailyCoffee: "Café diario",
        subscriptions: "Suscripciones",
        eatingOut: "Comer fuera",
        impulseClothing: "Ropa impulso",
        total: "Total",
        yearlyCost: "Coste Anual (€)",
        invested10years: "Invertido 10 años (€)",
        expense: "Gasto",
      },
      fire: {
        yearsToFire: "Años hasta FIRE",
        savingsRate: "Tasa de Ahorro",
      },
      crypto: {
        savingsAccount: "Cuenta Ahorro",
        bonds: "Bonos",
        sp500: "S&P 500",
        gold: "Oro",
        bitcoin: "Bitcoin",
        altcoins: "Altcoins",
        annualVolatility: "Volatilidad Anual (%)",
        maxDrawdown: "Caída Máxima (%)",
        asset: "Activo",
      },
      salary: {
        withoutNegotiating: "Sin negociar (+3%/año)",
        withNegotiating: "Negociando (+5%/año)",
        careerYears: "Años de carrera",
        yearlyEuro: "€/año",
      },
      firstSalary: {
        needs: "Necesidades (50%)",
        wants: "Deseos (30%)",
        savings: "Ahorro (20%)",
        rule502030FirstSalary: "Regla 50/30/20 para tu primer salario",
      },
      impulse: {
        impulsePurchases: "Compras impulsivas",
        fastFood: "Comida rápida",
        appsGames: "Apps/Juegos",
        unnecessaryClothing: "Ropa innecesaria",
        yearlyCost: "Coste Anual (€)",
        ifInvested5y: "Si se invirtiera 5 años (€)",
        category: "Categoría",
      },
      mortgage: {
        remainingPrincipal: "Capital pendiente",
        interestPaid: "Intereses pagados",
        years: "Años",
      },
      savings: {
        week1: "Sem 1",
        week10: "Sem 10",
        week20: "Sem 20",
        week30: "Sem 30",
        week40: "Sem 40",
        week52: "Sem 52",
        weeklySaving: "Ahorro semanal (€)",
        totalAccumulated: "Total acumulado (€)",
        week: "Semana",
      },
      beginners: {
        savingsAccount: "Cuenta ahorro",
        fixedDeposit: "Dep. plazo fijo",
        indexFunds: "Fondos índice",
        stocks: "Acciones",
        realEstate: "Inmobiliario",
        expectedReturn: "Retorno esperado (%)",
        riskLevel: "Riesgo (1-10)",
        investmentOption: "Opción de inversión",
      },
      costNotInvesting: {
        cashMoney: "Dinero en efectivo",
        invested7percent: "Invertido al 7%",
        years: "Años",
      },
      robo: {
        annualFee: "Comisión anual",
        minInvestment: "Mínimo inversión (k€)",
        personalization: "Personalización (1-10)",
        availability247: "Accesibilidad 24/7",
        emotionalManagement: "Gestión emocional",
        roboadvisor: "Roboadvisor",
        humanAdvisor: "Asesor humano",
        feature: "Característica",
      },
      bnpl: {
        cashPayment: "Pago contado",
        threeInstallments0: "3 cuotas 0%",
        sixInstallments: "6 cuotas",
        twelveInstallments: "12 cuotas",
        revolvingCard: "Tarjeta revólving",
        totalCost: "Coste total (€)",
        paymentMethod: "Método de pago",
      },
    },
  },
  de: {
    charts: {
      captions: {
        compoundInterest: "Vergleich: €10.000 mit einfachem vs Zinseszins bei 10% jährlich über 30 Jahre",
        emergencyFund: "Empfohlene Budgetverteilung zum Aufbau Ihres Notfallfonds",
        etfComparison: "Entwicklung von €100 investiert in verschiedene ETFs seit 2019",
        firstSalaryAllocation: "Empfohlene Verteilung Ihres ersten Gehalts: die 50/30/20 Regel",
        impulseBuyingCost: "Die wahren Kosten von Impulskäufen und ihr Potenzial bei Investition",
        inflationImpact: "Inflationsauswirkung: wie €10.000 bei 3% jährlicher Inflation an Kaufkraft verlieren",
        fireTimeline: "Jahre bis zur finanziellen Unabhängigkeit nach Sparquote",
        opportunityCost: "Opportunitätskosten: kleine unsichtbare Ausgaben und ihre Auswirkung bei Investition",
        lifestyleInflation: "Lifestyle-Inflation: Ausgaben die mit dem Gehalt wachsen vs notwendige Ausgaben",
        monthlySavingsChallenge: "52-Wochen-Spar-Challenge: Beginne mit €1 und ende mit €1.378 gespart",
        costNotInvesting: "Die Kosten des Nicht-Investierens: €10.000 bar vs bei 7% investiert über 30 Jahre",
        retirementProjection: "Rentensparen-Projektion: €500/Monat sparen ab 25 Jahren",
        mortgageComparison: "€200.000 Hypothekenentwicklung: Restkapital vs gezahlte Zinsen",
        riskReturn: "Anlageprofilvergleich: erwartete Rendite vs Volatilität",
        roboadvisorComparison: "Vergleich: Roboadvisors vs menschliche Berater nach verschiedenen Kriterien",
        salaryGrowth: "Gehaltswachstum: Verhandeln vs nicht verhandeln über 25 Jahre",
        investingBeginners: "Anlageoptionen-Vergleich für Anfänger: Rendite vs Risiko",
        dcaVsLumpsum: "DCA (€1.000/Monat) vs Einmalanlage (€12.000) Vergleich bei 6% jährlicher Rendite",
        cryptoVolatility: "Volatilitätsvergleich: Kryptowährungen vs traditionelle Anlagen",
        dividendGrowth: "Wachstum mit Dividendenreinvestition: €10.000 anfänglich mit 4% jährlicher Dividende",
        bnplCost: "Wahre Kosten eines €100 Kaufs nach Finanzierungsmethode",
      },
      compoundInterest: {
        simpleInterest: "Einfacher Zins",
        compoundInterest: "Zinseszins",
        years: "Jahre",
      },
      inflation: {
        nominalValue: "Nominalwert",
        purchasingPower: "Reale Kaufkraft",
        yearsInflation3: "Jahre (3% Inflation)",
      },
      savingsGrowth: {
        monthlySaving: "Monatliche Ersparnis",
        totalAccumulated: "Gesamtbetrag",
        month: "Monat",
        jan: "Jan", feb: "Feb", mar: "Mär", apr: "Apr", may: "Mai", jun: "Jun",
        jul: "Jul", aug: "Aug", sep: "Sep", oct: "Okt", nov: "Nov", dec: "Dez",
      },
      investmentComparison: {
        savingsAccount: "Sparkonto",
        govBonds: "Staatsanleihen",
        corpBonds: "Unternehmensanleihen",
        realEstate: "Immobilien",
        stocks: "Aktien",
        crypto: "Krypto",
        expectedReturn: "Erwartete Rendite (%)",
        riskLevel: "Risikoniveau",
        assetType: "Anlageklasse",
      },
      emergencyFund: {
        essentialExpenses: "Notwendige Ausgaben",
        variableExpenses: "Variable Ausgaben",
        savingsInvestment: "Sparen/Investieren",
        recommendedDistribution: "Empfohlene Budgetverteilung",
      },
      dcaVsLumpsum: {
        dca: "DCA (€1000/Monat)",
        lumpsum: "Einmalanlage (€12000)",
        months: "Monate",
      },
      riskReturn: {
        conservative: "Konservativ",
        moderate: "Moderat",
        aggressive: "Aggressiv",
        veryAggressive: "Sehr Aggressiv",
        annualReturn: "Jährliche Rendite (%)",
        volatility: "Volatilität (%)",
        riskProfile: "Risikoprofil",
      },
      retirement: {
        withoutInvesting: "Sparen ohne Investieren",
        invested: "Investiert (7% Rendite)",
        age: "Alter",
      },
      budgetBreakdown: {
        housing: "Wohnen",
        food: "Essen",
        transport: "Transport",
        utilities: "Nebenkosten",
        savings: "Sparen",
        leisure: "Freizeit",
        rule502030: "50/30/20 Regel angepasst",
      },
      etf: {
        sp500: "S&P 500",
        msciWorld: "MSCI World",
        emerging: "Schwellenländer",
        year: "Jahr",
        initial100: "€100 anfänglich",
      },
      dividend: {
        withoutReinvesting: "Dividenden ohne Reinvestition",
        withReinvesting: "Dividenden reinvestiert",
        years: "Jahre",
      },
      mortgageAmortization: {
        pendingCapital: "Restkapital",
        totalPaid: "Gesamtzahlung",
        years: "Jahre",
      },
      taxBrackets: {
        marginalRate: "Grenzsteuersatz (%)",
        bracket: "Stufe",
      },
      lifestyle: {
        necessaryExpenses: "Notwendige Ausgaben",
        withInflation: "Mit Lifestyle-Inflation",
        annualSalary: "Jahresgehalt",
        expenses: "€ Ausgaben",
      },
      opportunity: {
        dailyCoffee: "Täglicher Kaffee",
        subscriptions: "Abonnements",
        eatingOut: "Auswärts essen",
        impulseClothing: "Impulskäufe Kleidung",
        total: "Gesamt",
        yearlyCost: "Jährliche Kosten (€)",
        invested10years: "10 Jahre investiert (€)",
        expense: "Ausgabe",
      },
      fire: {
        yearsToFire: "Jahre bis FIRE",
        savingsRate: "Sparquote",
      },
      crypto: {
        savingsAccount: "Sparkonto",
        bonds: "Anleihen",
        sp500: "S&P 500",
        gold: "Gold",
        bitcoin: "Bitcoin",
        altcoins: "Altcoins",
        annualVolatility: "Jährliche Volatilität (%)",
        maxDrawdown: "Maximaler Verlust (%)",
        asset: "Anlage",
      },
      salary: {
        withoutNegotiating: "Ohne Verhandeln (+3%/Jahr)",
        withNegotiating: "Mit Verhandeln (+5%/Jahr)",
        careerYears: "Karrierejahre",
        yearlyEuro: "€/Jahr",
      },
      firstSalary: {
        needs: "Bedürfnisse (50%)",
        wants: "Wünsche (30%)",
        savings: "Sparen (20%)",
        rule502030FirstSalary: "50/30/20 Regel für dein erstes Gehalt",
      },
      impulse: {
        impulsePurchases: "Impulskäufe",
        fastFood: "Fast Food",
        appsGames: "Apps/Spiele",
        unnecessaryClothing: "Unnötige Kleidung",
        yearlyCost: "Jährliche Kosten (€)",
        ifInvested5y: "Wenn 5 Jahre investiert (€)",
        category: "Kategorie",
      },
      mortgage: {
        remainingPrincipal: "Restschuld",
        interestPaid: "Gezahlte Zinsen",
        years: "Jahre",
      },
      savings: {
        week1: "Woche 1",
        week10: "Woche 10",
        week20: "Woche 20",
        week30: "Woche 30",
        week40: "Woche 40",
        week52: "Woche 52",
        weeklySaving: "Wöchentliche Ersparnis (€)",
        totalAccumulated: "Gesamtbetrag (€)",
        week: "Woche",
      },
      beginners: {
        savingsAccount: "Sparkonto",
        fixedDeposit: "Festgeld",
        indexFunds: "Indexfonds",
        stocks: "Aktien",
        realEstate: "Immobilien",
        expectedReturn: "Erwartete Rendite (%)",
        riskLevel: "Risiko (1-10)",
        investmentOption: "Anlageoption",
      },
      costNotInvesting: {
        cashMoney: "Bargeld",
        invested7percent: "Investiert bei 7%",
        years: "Jahre",
      },
      robo: {
        annualFee: "Jährliche Gebühr",
        minInvestment: "Mindestanlage (k€)",
        personalization: "Personalisierung (1-10)",
        availability247: "24/7 Verfügbarkeit",
        emotionalManagement: "Emotionsmanagement",
        roboadvisor: "Roboadvisor",
        humanAdvisor: "Menschlicher Berater",
        feature: "Merkmal",
      },
      bnpl: {
        cashPayment: "Barzahlung",
        threeInstallments0: "3 Raten 0%",
        sixInstallments: "6 Raten",
        twelveInstallments: "12 Raten",
        revolvingCard: "Revolving-Karte",
        totalCost: "Gesamtkosten (€)",
        paymentMethod: "Zahlungsmethode",
      },
    },
  },
  fr: {
    charts: {
      captions: {
        compoundInterest: "Comparaison: €10 000 avec intérêt simple vs composé à 10% annuel sur 30 ans",
        emergencyFund: "Répartition budgétaire recommandée pour constituer votre fonds d'urgence",
        etfComparison: "Évolution de €100 investis dans différents ETFs depuis 2019",
        firstSalaryAllocation: "Répartition recommandée de votre premier salaire: la règle 50/30/20",
        impulseBuyingCost: "Le coût réel des achats impulsifs et leur potentiel si investis",
        inflationImpact: "Impact de l'inflation: comment €10 000 perdent du pouvoir d'achat avec 3% d'inflation annuelle",
        fireTimeline: "Années jusqu'à l'indépendance financière selon votre taux d'épargne",
        opportunityCost: "Coût d'opportunité: petites dépenses invisibles et leur impact si investies",
        lifestyleInflation: "Impact de l'inflation du mode de vie: dépenses qui croissent avec le salaire vs dépenses nécessaires",
        monthlySavingsChallenge: "Défi d'épargne 52 semaines: commencez avec €1 et terminez avec €1 378 épargnés",
        costNotInvesting: "Le coût de ne pas investir: €10 000 en espèces vs investis à 7% sur 30 ans",
        retirementProjection: "Projection d'épargne retraite: épargner €500/mois dès 25 ans",
        mortgageComparison: "Évolution d'un prêt de €200 000: capital restant vs intérêts payés",
        riskReturn: "Comparaison des profils d'investissement: rendement attendu vs volatilité",
        roboadvisorComparison: "Comparaison: Roboadvisors vs Conseillers Humains selon différents critères",
        salaryGrowth: "Croissance salariale: négocier vs ne pas négocier sur 25 ans",
        investingBeginners: "Comparaison des options d'investissement pour débutants: rendement vs risque",
        dcaVsLumpsum: "Comparaison DCA (€1 000/mois) vs Investissement unique (€12 000) avec 6% de rendement annuel",
        cryptoVolatility: "Comparaison de volatilité: cryptomonnaies vs actifs traditionnels",
        dividendGrowth: "Croissance avec réinvestissement des dividendes: €10 000 initiaux avec 4% de dividende annuel",
        bnplCost: "Coût réel d'un achat de €100 selon la méthode de financement",
      },
      compoundInterest: {
        simpleInterest: "Intérêt Simple",
        compoundInterest: "Intérêt Composé",
        years: "Années",
      },
      inflation: {
        nominalValue: "Valeur Nominale",
        purchasingPower: "Pouvoir d'Achat Réel",
        yearsInflation3: "Années (inflation 3%)",
      },
      savingsGrowth: {
        monthlySaving: "Épargne Mensuelle",
        totalAccumulated: "Total Accumulé",
        month: "Mois",
        jan: "Jan", feb: "Fév", mar: "Mar", apr: "Avr", may: "Mai", jun: "Juin",
        jul: "Juil", aug: "Août", sep: "Sep", oct: "Oct", nov: "Nov", dec: "Déc",
      },
      investmentComparison: {
        savingsAccount: "Compte Épargne",
        govBonds: "Obl. État",
        corpBonds: "Obl. Entreprises",
        realEstate: "Immobilier",
        stocks: "Actions",
        crypto: "Crypto",
        expectedReturn: "Rendement Attendu (%)",
        riskLevel: "Niveau de Risque",
        assetType: "Type d'Actif",
      },
      emergencyFund: {
        essentialExpenses: "Dépenses Essentielles",
        variableExpenses: "Dépenses Variables",
        savingsInvestment: "Épargne/Investissement",
        recommendedDistribution: "Répartition Budgétaire Recommandée",
      },
      dcaVsLumpsum: {
        dca: "DCA (€1000/mois)",
        lumpsum: "Somme Forfaitaire (€12000)",
        months: "Mois",
      },
      riskReturn: {
        conservative: "Conservateur",
        moderate: "Modéré",
        aggressive: "Agressif",
        veryAggressive: "Très Agressif",
        annualReturn: "Rendement Annuel (%)",
        volatility: "Volatilité (%)",
        riskProfile: "Profil de Risque",
      },
      retirement: {
        withoutInvesting: "Épargne sans investir",
        invested: "Investie (rendement 7%)",
        age: "Âge",
      },
      budgetBreakdown: {
        housing: "Logement",
        food: "Alimentation",
        transport: "Transport",
        utilities: "Services",
        savings: "Épargne",
        leisure: "Loisirs",
        rule502030: "Règle 50/30/20 Adaptée",
      },
      etf: {
        sp500: "S&P 500",
        msciWorld: "MSCI World",
        emerging: "Marchés Émergents",
        year: "Année",
        initial100: "€100 initiaux",
      },
      dividend: {
        withoutReinvesting: "Dividendes sans réinvestissement",
        withReinvesting: "Dividendes réinvestis",
        years: "Années",
      },
      mortgageAmortization: {
        pendingCapital: "Capital Restant",
        totalPaid: "Total Payé",
        years: "Années",
      },
      taxBrackets: {
        marginalRate: "Taux Marginal (%)",
        bracket: "Tranche",
      },
      lifestyle: {
        necessaryExpenses: "Dépenses Nécessaires",
        withInflation: "Avec Inflation du Mode de Vie",
        annualSalary: "Salaire Annuel",
        expenses: "€ Dépenses",
      },
      opportunity: {
        dailyCoffee: "Café quotidien",
        subscriptions: "Abonnements",
        eatingOut: "Restaurants",
        impulseClothing: "Vêtements impulsifs",
        total: "Total",
        yearlyCost: "Coût Annuel (€)",
        invested10years: "Investi 10 ans (€)",
        expense: "Dépense",
      },
      fire: {
        yearsToFire: "Années jusqu'à FIRE",
        savingsRate: "Taux d'Épargne",
      },
      crypto: {
        savingsAccount: "Compte Épargne",
        bonds: "Obligations",
        sp500: "S&P 500",
        gold: "Or",
        bitcoin: "Bitcoin",
        altcoins: "Altcoins",
        annualVolatility: "Volatilité Annuelle (%)",
        maxDrawdown: "Perte Maximale (%)",
        asset: "Actif",
      },
      salary: {
        withoutNegotiating: "Sans négocier (+3%/an)",
        withNegotiating: "En négociant (+5%/an)",
        careerYears: "Années de carrière",
        yearlyEuro: "€/an",
      },
      firstSalary: {
        needs: "Besoins (50%)",
        wants: "Envies (30%)",
        savings: "Épargne (20%)",
        rule502030FirstSalary: "Règle 50/30/20 pour votre premier salaire",
      },
      impulse: {
        impulsePurchases: "Achats impulsifs",
        fastFood: "Fast Food",
        appsGames: "Apps/Jeux",
        unnecessaryClothing: "Vêtements inutiles",
        yearlyCost: "Coût Annuel (€)",
        ifInvested5y: "Si investi 5 ans (€)",
        category: "Catégorie",
      },
      mortgage: {
        remainingPrincipal: "Capital restant",
        interestPaid: "Intérêts payés",
        years: "Années",
      },
      savings: {
        week1: "Sem 1",
        week10: "Sem 10",
        week20: "Sem 20",
        week30: "Sem 30",
        week40: "Sem 40",
        week52: "Sem 52",
        weeklySaving: "Épargne hebdomadaire (€)",
        totalAccumulated: "Total accumulé (€)",
        week: "Semaine",
      },
      beginners: {
        savingsAccount: "Compte épargne",
        fixedDeposit: "Dépôt à terme",
        indexFunds: "Fonds indiciels",
        stocks: "Actions",
        realEstate: "Immobilier",
        expectedReturn: "Rendement attendu (%)",
        riskLevel: "Risque (1-10)",
        investmentOption: "Option d'investissement",
      },
      costNotInvesting: {
        cashMoney: "Argent liquide",
        invested7percent: "Investi à 7%",
        years: "Années",
      },
      robo: {
        annualFee: "Frais annuels",
        minInvestment: "Investissement min (k€)",
        personalization: "Personnalisation (1-10)",
        availability247: "Disponibilité 24/7",
        emotionalManagement: "Gestion émotionnelle",
        roboadvisor: "Roboadvisor",
        humanAdvisor: "Conseiller humain",
        feature: "Caractéristique",
      },
      bnpl: {
        cashPayment: "Paiement comptant",
        threeInstallments0: "3 mensualités 0%",
        sixInstallments: "6 mensualités",
        twelveInstallments: "12 mensualités",
        revolvingCard: "Carte revolving",
        totalCost: "Coût total (€)",
        paymentMethod: "Méthode de paiement",
      },
    },
  },
  hi: {
    charts: {
      captions: {
        compoundInterest: "तुलना: €10,000 साधारण ब्याज बनाम चक्रवृद्धि ब्याज 10% वार्षिक पर 30 वर्षों में",
        emergencyFund: "आपातकालीन निधि बनाने के लिए अनुशंसित बजट वितरण",
        etfComparison: "2019 से विभिन्न ETFs में €100 निवेश का विकास",
        firstSalaryAllocation: "आपकी पहली सैलरी का अनुशंसित वितरण: 50/30/20 नियम",
        impulseBuyingCost: "आवेगी खरीदारी की वास्तविक लागत और निवेश करने पर उनकी क्षमता",
        inflationImpact: "मुद्रास्फीति का प्रभाव: 3% वार्षिक मुद्रास्फीति पर €10,000 कैसे क्रय शक्ति खोते हैं",
        fireTimeline: "आपकी बचत दर के अनुसार वित्तीय स्वतंत्रता तक के वर्ष",
        opportunityCost: "अवसर लागत: छोटे अदृश्य खर्च और निवेश करने पर उनका प्रभाव",
        lifestyleInflation: "जीवनशैली मुद्रास्फीति प्रभाव: वेतन के साथ बढ़ने वाले खर्च बनाम आवश्यक खर्च",
        monthlySavingsChallenge: "52-सप्ताह बचत चुनौती: €1 से शुरू करें और €1,378 बचाकर समाप्त करें",
        costNotInvesting: "निवेश न करने की लागत: €10,000 नकद बनाम 30 वर्षों में 7% पर निवेशित",
        retirementProjection: "सेवानिवृत्ति बचत प्रक्षेपण: 25 वर्ष की आयु से €500/माह बचत",
        mortgageComparison: "€200,000 बंधक विकास: शेष मूलधन बनाम भुगतान किया ब्याज",
        riskReturn: "निवेश प्रोफ़ाइल तुलना: अपेक्षित रिटर्न बनाम अस्थिरता",
        roboadvisorComparison: "तुलना: विभिन्न मानदंडों पर रोबोएडवाइजर बनाम मानव सलाहकार",
        salaryGrowth: "वेतन वृद्धि: 25 वर्षों में बातचीत करना बनाम न करना",
        investingBeginners: "शुरुआती लोगों के लिए निवेश विकल्प तुलना: रिटर्न बनाम जोखिम",
        dcaVsLumpsum: "DCA (€1,000/माह) बनाम एकमुश्त (€12,000) 6% वार्षिक रिटर्न के साथ तुलना",
        cryptoVolatility: "अस्थिरता तुलना: क्रिप्टोकरेंसी बनाम पारंपरिक संपत्ति",
        dividendGrowth: "लाभांश पुनर्निवेश के साथ वृद्धि: €10,000 प्रारंभिक 4% वार्षिक लाभांश के साथ",
        bnplCost: "वित्तपोषण विधि के अनुसार €100 खरीद की वास्तविक लागत",
      },
      compoundInterest: {
        simpleInterest: "साधारण ब्याज",
        compoundInterest: "चक्रवृद्धि ब्याज",
        years: "वर्ष",
      },
      inflation: {
        nominalValue: "नाममात्र मूल्य",
        purchasingPower: "वास्तविक क्रय शक्ति",
        yearsInflation3: "वर्ष (3% मुद्रास्फीति)",
      },
      savingsGrowth: {
        monthlySaving: "मासिक बचत",
        totalAccumulated: "कुल संचित",
        month: "महीना",
        jan: "जन", feb: "फर", mar: "मार्च", apr: "अप्रैल", may: "मई", jun: "जून",
        jul: "जुला", aug: "अग", sep: "सित", oct: "अक्टू", nov: "नव", dec: "दिस",
      },
      investmentComparison: {
        savingsAccount: "बचत खाता",
        govBonds: "सरकारी बॉन्ड",
        corpBonds: "कॉर्प बॉन्ड",
        realEstate: "रियल एस्टेट",
        stocks: "स्टॉक्स",
        crypto: "क्रिप्टो",
        expectedReturn: "अपेक्षित रिटर्न (%)",
        riskLevel: "जोखिम स्तर",
        assetType: "परिसंपत्ति प्रकार",
      },
      emergencyFund: {
        essentialExpenses: "आवश्यक खर्च",
        variableExpenses: "परिवर्तनीय खर्च",
        savingsInvestment: "बचत/निवेश",
        recommendedDistribution: "अनुशंसित बजट वितरण",
      },
      dcaVsLumpsum: {
        dca: "DCA (€1000/माह)",
        lumpsum: "एकमुश्त (€12000)",
        months: "महीने",
      },
      riskReturn: {
        conservative: "रूढ़िवादी",
        moderate: "मध्यम",
        aggressive: "आक्रामक",
        veryAggressive: "बहुत आक्रामक",
        annualReturn: "वार्षिक रिटर्न (%)",
        volatility: "अस्थिरता (%)",
        riskProfile: "जोखिम प्रोफ़ाइल",
      },
      retirement: {
        withoutInvesting: "बिना निवेश के बचत",
        invested: "निवेशित (7% रिटर्न)",
        age: "उम्र",
      },
      budgetBreakdown: {
        housing: "आवास",
        food: "भोजन",
        transport: "परिवहन",
        utilities: "उपयोगिताएं",
        savings: "बचत",
        leisure: "मनोरंजन",
        rule502030: "50/30/20 नियम अनुकूलित",
      },
      etf: {
        sp500: "S&P 500",
        msciWorld: "MSCI World",
        emerging: "उभरते बाजार",
        year: "वर्ष",
        initial100: "€100 प्रारंभिक",
      },
      dividend: {
        withoutReinvesting: "बिना पुनर्निवेश के लाभांश",
        withReinvesting: "पुनर्निवेशित लाभांश",
        years: "वर्ष",
      },
      mortgageAmortization: {
        pendingCapital: "बकाया पूंजी",
        totalPaid: "कुल भुगतान",
        years: "वर्ष",
      },
      taxBrackets: {
        marginalRate: "सीमांत दर (%)",
        bracket: "स्लैब",
      },
      lifestyle: {
        necessaryExpenses: "आवश्यक खर्च",
        withInflation: "जीवनशैली मुद्रास्फीति के साथ",
        annualSalary: "वार्षिक वेतन",
        expenses: "€ खर्च",
      },
      opportunity: {
        dailyCoffee: "दैनिक कॉफी",
        subscriptions: "सब्सक्रिप्शन",
        eatingOut: "बाहर खाना",
        impulseClothing: "आवेग में कपड़े",
        total: "कुल",
        yearlyCost: "वार्षिक लागत (€)",
        invested10years: "10 वर्ष निवेशित (€)",
        expense: "खर्च",
      },
      fire: {
        yearsToFire: "FIRE तक वर्ष",
        savingsRate: "बचत दर",
      },
      crypto: {
        savingsAccount: "बचत खाता",
        bonds: "बॉन्ड",
        sp500: "S&P 500",
        gold: "सोना",
        bitcoin: "बिटकॉइन",
        altcoins: "ऑल्टकॉइन",
        annualVolatility: "वार्षिक अस्थिरता (%)",
        maxDrawdown: "अधिकतम गिरावट (%)",
        asset: "परिसंपत्ति",
      },
      salary: {
        withoutNegotiating: "बिना बातचीत (+3%/वर्ष)",
        withNegotiating: "बातचीत के साथ (+5%/वर्ष)",
        careerYears: "कैरियर वर्ष",
        yearlyEuro: "€/वर्ष",
      },
      firstSalary: {
        needs: "आवश्यकताएं (50%)",
        wants: "इच्छाएं (30%)",
        savings: "बचत (20%)",
        rule502030FirstSalary: "आपकी पहली सैलरी के लिए 50/30/20 नियम",
      },
      impulse: {
        impulsePurchases: "आवेगी खरीदारी",
        fastFood: "फास्ट फूड",
        appsGames: "ऐप्स/गेम्स",
        unnecessaryClothing: "अनावश्यक कपड़े",
        yearlyCost: "वार्षिक लागत (€)",
        ifInvested5y: "अगर 5 वर्ष निवेश किया (€)",
        category: "श्रेणी",
      },
      mortgage: {
        remainingPrincipal: "शेष मूलधन",
        interestPaid: "भुगतान किया ब्याज",
        years: "वर्ष",
      },
      savings: {
        week1: "सप्ताह 1",
        week10: "सप्ताह 10",
        week20: "सप्ताह 20",
        week30: "सप्ताह 30",
        week40: "सप्ताह 40",
        week52: "सप्ताह 52",
        weeklySaving: "साप्ताहिक बचत (€)",
        totalAccumulated: "कुल संचित (€)",
        week: "सप्ताह",
      },
      beginners: {
        savingsAccount: "बचत खाता",
        fixedDeposit: "सावधि जमा",
        indexFunds: "इंडेक्स फंड",
        stocks: "स्टॉक्स",
        realEstate: "रियल एस्टेट",
        expectedReturn: "अपेक्षित रिटर्न (%)",
        riskLevel: "जोखिम (1-10)",
        investmentOption: "निवेश विकल्प",
      },
      costNotInvesting: {
        cashMoney: "नकद धन",
        invested7percent: "7% पर निवेशित",
        years: "वर्ष",
      },
      robo: {
        annualFee: "वार्षिक शुल्क",
        minInvestment: "न्यूनतम निवेश (k€)",
        personalization: "वैयक्तिकरण (1-10)",
        availability247: "24/7 उपलब्धता",
        emotionalManagement: "भावनात्मक प्रबंधन",
        roboadvisor: "रोबोएडवाइजर",
        humanAdvisor: "मानव सलाहकार",
        feature: "विशेषता",
      },
      bnpl: {
        cashPayment: "नकद भुगतान",
        threeInstallments0: "3 किस्तें 0%",
        sixInstallments: "6 किस्तें",
        twelveInstallments: "12 किस्तें",
        revolvingCard: "रिवॉल्विंग कार्ड",
        totalCost: "कुल लागत (€)",
        paymentMethod: "भुगतान विधि",
      },
    },
  },
};
